// Decode rot13 encoded email addresses contained in script tags.
//
// Keeping IE11 compatible and free of dependencies for portability.

/*
eslint-disable
func-names,
no-var,
prefer-arrow-callback,
*/

(function () {
  var doc = document;
  var ENCODED_SELECTOR = '.em-enc';
  var decodeContainer = doc.createElement('div');

  /**
   * @param {*} obj
   * @returns {Array}
   */
  function toArray(obj) {
    return Array.prototype.slice.call(obj);
  }

  /**
   * @param {string} char
   * @returns {string}
   */
  function rot13(char) {
    return String.fromCharCode(
      char.charCodeAt(0) + (char.toUpperCase() <= 'M' ? 13 : -13),
    );
  }

  /**
   * @param {HTMLElement} span - Node containing the encoded email.
   */
  function decodeEmail(span) {
    var script = span.querySelector('script');
    var spanParent = span.parentNode;
    // Restore the @ sign, trim trailing quotes (handling optional semicolon),
    // restore escaped single quotes and run rot13.
    decodeContainer.innerHTML = script.textContent
      .replace(/£/g, '@')
      .replace(/^'|';*$/g, '')
      .replace(/\\'/g, "'")
      .replace(/[a-z]/gi, rot13);
    toArray(decodeContainer.childNodes).forEach(function (node) {
      spanParent.insertBefore(node, span);
    });
    spanParent.removeChild(span);
  }

  function ready() {
    toArray(doc.querySelectorAll(ENCODED_SELECTOR)).forEach(function (span) {
      decodeEmail(span);
    });
  }

  if (doc.readyState === 'interactive' || doc.readyState === 'complete') {
    ready();
  } else {
    doc.addEventListener('DOMContentLoaded', ready, false);
  }
})();
